import { render, staticRenderFns } from "./DeliveryZoneGroupForm.vue?vue&type=template&id=d36961c2&"
import script from "./DeliveryZoneGroupForm.vue?vue&type=script&lang=ts&"
export * from "./DeliveryZoneGroupForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports